import React from "react";
import styled from "styled-components";
import { greyText } from "../../../styles";
import { CompassParagraph } from "../styledComponents";
import { AccentCard } from "../AccentCard";

const DescriptionLabel = styled(CompassParagraph)`
  margin: 0;
  font-size: 11px;
  color: ${greyText};
  margin-bottom: 4px;
`;

const DescriptionText = styled(CompassParagraph)`
  margin: 0;
  font-size: 13px;
  color: ${greyText};
`;

export interface ModalDescriptionBoxProps {
  /** Optional label above the content */
  label?: string;
  /** Text content to display */
  content: string;
  /** Padding (default: 12px) */
  padding?: string;
  /** Left border accent color (default: darkGreen) */
  accentColor?: string;
  /** Min height to prevent layout shift */
  minHeight?: number;
  /** Custom content instead of text */
  children?: React.ReactNode;
}

/**
 * A grey background box with left accent for displaying descriptive text
 */
export const ModalDescriptionBox: React.FC<ModalDescriptionBoxProps> = ({
  label,
  content,
  padding = "12px",
  accentColor,
  minHeight,
  children,
}) => {
  return (
    <AccentCard
      direction="column"
      padding={padding}
      accentColor={accentColor}
      gap={4}
      minHeight={minHeight}
    >
      {label && <DescriptionLabel>{label}</DescriptionLabel>}
      {children || <DescriptionText>{content}</DescriptionText>}
    </AccentCard>
  );
};
